/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { email, mobile, recaptcha, mobile_otp, email_otp},
} = checkout;

const validations = [
  Yup.object().shape({
    [email.name]: Yup.string().email('Invalid email').required(email.errorMsg),
    [mobile.name]: Yup.string().required(mobile.errorMsg),
    [recaptcha.name]:  Yup.string().required(recaptcha.errorMsg)
  }),
  Yup.object().shape({
    [mobile_otp.name]: Yup.string().required(mobile_otp.errorMsg),
  }),
  Yup.object().shape({
    [email_otp.name]: Yup.string().required(email_otp.errorMsg),
  }),
];

export default validations;
